import React, { useCallback, useEffect, useState } from "react";
import { FaWallet, FaArrowDown, FaArrowUp } from "react-icons/fa";
import Backend from "../../../../Backend/Backend";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import "./Wallet.css";
import { useNavigate } from "react-router-dom";

const fmt = require("indian-number-format");

const backend = await new Backend().init();

function WalletDropdown({ onOpenDeposit, onOpenWithdraw }) {

  const navigate = useNavigate()

  const userType = Number(localStorage.getItem("user_type") || 7);

  const totalMaster = useSelector((state) => state.totalmaster || 0);

  const [loading, setLoading] = useState(false);
  const [depositCurrent, setDepositCurrent] = useState(0);
  const [profitLoss, setProfitLoss] = useState(0);
  const [equity, setEquity] = useState(0);

  const [isDollar, setisDollar] = useState(0);

  const isProfit = totalMaster >= 0;
  const isProfitNew = profitLoss >= 0;

  const loadProfitLoss = useCallback(async () => {
    if (!userType) return;
    if (userType !== 4) return;

    setLoading(true);

    try {
      const baseData = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
      };

      const data =
        userType === 4
          ? baseData
          : { ...baseData, user_id: localStorage.getItem("id") };

      let res;
      switch (userType) {
        case 4:
          res = await backend.profit_loss(data);
          break;
        default:
          return;
      }

      if (res?.error === "False") {
        setDepositCurrent(+res.deposit_current || 0);
        setProfitLoss(+res.profit_loss || 0);
        setEquity(+res.equity || 0);
        setisDollar(res.isDollar);
      } else {
        if (res?.logout === 1) {
          window.LogOut?.();
        } else {
          toast.error(res?.message || "Failed to load P/L data");
        }
      }
    } catch (err) {
      toast.error("Error loading P/L data");
      console.error("TopCard Load Error:", err);
    } finally {
      setLoading(false);
    }
  }, [userType]);

  useEffect(() => {
    if (userType) loadProfitLoss();
  }, [userType, loadProfitLoss]);

  const netEquity = (parseFloat(equity) + parseFloat(totalMaster || 0)).toFixed(
    0,
  );

  return (
    <div className="wallet-dropdown">
      {/* Header */}
      <div className="wallet-header">
        <FaWallet className="wallet-icon " />
        <span>My Wallet</span>
      </div>

      {/* Balance */}
      <div className="wallet-balance">
        <p className="font-semibold">Total Balance</p>
        <h2>
          {fmt.format(netEquity)} {isDollar === 1 ? "$" : ""}
        </h2>
      </div>

      {/* Stats */}
      <div className="wallet-stats">
        <div>
          <span className="font-semibold">CREDIT</span>
          <strong>
            {depositCurrent.toLocaleString("en-IN")} {isDollar === 1 ? "$" : ""}
          </strong>
        </div>
        <div>
          <span className="font-semibold">BOOKED</span>
          <strong
            className={`font-semibold ${isProfitNew ? "text-[var(--buymeta)]" : "text-[var(--sellmeta)]"}`}
          >
            {profitLoss.toLocaleString("en-IN")} {isDollar === 1 ? "$" : ""}
          </strong>
        </div>

        <div>
          <span className="font-semibold">P/L</span>
          <strong
            className={`font-semibold ${isProfit ? "text-[var(--buymeta)]" : "text-[var(--sellmeta)]"}`}
          >
            {totalMaster.toLocaleString("en-IN")} {isDollar === 1 ? "$" : ""}
          </strong>
        </div>
      </div>

      <div className="wallet-actions">
        <button className="action-btn deposit-btn" onClick={onOpenDeposit}>
          <FaArrowDown className="icon" />
          <span>Deposit</span>
        </button>

        <button className="action-btn withdraw-btn" onClick={onOpenWithdraw}>
          <FaArrowUp className="icon" />
          <span>Withdraw</span>
        </button>
      </div>
      {/* <div className="wallet-actions">
        <button className="action-btn history-btn" onClick={()=>{
          navigate("/TransactionHistory")
        }}>
          📜
          <span>Transactions</span>
        </button>
      </div> */}
    </div>
  );
}

export default WalletDropdown;
